import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import MuiInputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';
import { padStart } from 'lodash';
import Hint from '../Hint/Hint.js';
import 'date-fns';
import { isNumberInput } from '../../utils/isNumberInput.js';

const _BaseTimeInput = styled(MuiInputBase) `
  transition: color ${({ theme }) => theme.transitions.duration.fast} linear,
    background-color ${({ theme }) => theme.transitions.duration.fast} linear,
    border ${({ theme }) => theme.transitions.duration.fast} linear;
  text-align: center;
  cursor: inherit;
  background-color: transparent;
  ${({ theme, value, disabled, fullWidth }) => `
      .MuiInputBase-input {
        padding: 0;
        height: 11px;
        width: ${fullWidth ? '100%' : '14px'};
        direction: rtl;
        user-select: ${disabled ? 'none' : 'auto'};
        -moz-appearance: textfield;
        &::placeholder {
          opacity: 1;
        }
        &::selection {
          background: transparent;
          color: ${theme.palette.primary.main};
        }
      }
      :before {
        content: '—';
        text-align: center;
        color: ${disabled ? theme.palette.N20.main : 'currentColor'};
        display: ${value ? 'none' : 'block'};
        cursor: ${disabled ? 'not-allowed' : 'initial'}; ;
        width: 14px;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        z-index: 3;
      }
      &.Mui-focused {
        color: ${theme.palette.primary.main};
        :before {
          color: transparent;
          display: none;
        }
      }
      .Mui-disabled {
        cursor: not-allowed;
        user-select: none;
        color: ${theme.palette.N20.main};
        -webkit-text-fill-color: ${theme.palette.N20.main};
      }
    `};
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
    margin: 0;
  }
`;
const formatValue = (value, max, withZeroPadding) => {
    if (!value || !max) {
        return '';
    }
    const maxNumberLength = `${max}`.length;
    if (value.length > maxNumberLength) {
        return value.slice(value.length - maxNumberLength);
    }
    else if (withZeroPadding) {
        return padStart(value, maxNumberLength, '0');
    }
    else {
        return value;
    }
};
const BaseTimeInput = (_a) => {
    var { onValueChange, hint = '', value, inputProps, withZeroPadding, disabled } = _a, rest = __rest(_a, ["onValueChange", "hint", "value", "inputProps", "withZeroPadding", "disabled"]);
    const hideHint = !hint || rest.error || !value;
    const onChange = useCallback((e) => {
        if (onValueChange && isNumberInput(e.target.value, 'digitsOnly')) {
            onValueChange(formatValue(e.target.value, inputProps === null || inputProps === void 0 ? void 0 : inputProps.max, withZeroPadding));
        }
    }, [inputProps === null || inputProps === void 0 ? void 0 : inputProps.max, onValueChange, withZeroPadding]);
    return (jsx(Hint, Object.assign({ title: hint, disabled: hideHint, disableFocusListener: true }, { children: jsx(_BaseTimeInput, Object.assign({}, rest, { value: value, inputProps: inputProps, disabled: disabled, onChange: onChange, onFocus: e => e.target.select() })) })));
};

export { BaseTimeInput as default };
//# sourceMappingURL=BaseTimeInput.js.map
